import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; 

import './styles/main.scss';

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import PortfolioPage from "./pages/PortfolioPage";
import PortfolioDetailed from "./components/pages/portfoliopage/PortfolioDetailed";
import OriflamePage from "./pages/OriflamePage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/common/ScrollToTop";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        {/* <Route exact path="/about" element={<AboutPage />} /> */}
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/portfolio/:id" element={<PortfolioDetailed />} />
        {/* <Route exact path="/oriflame" element={<OriflamePage />} /> */}
        {/* <Route exact path="/contact" element={<ContactPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
